import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// DONT CHANGE THIS IMPORT (MUST FOLLOW THE FORMAT IN edit-package-json.js)
import {RonaldeContext as Context} from './ronalde/Ronalde';

ReactDOM.render(
    <React.StrictMode>
        <App context={new Context()}/>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
